for (const dialog of document.querySelectorAll(
  "dialog"
) as NodeListOf<HTMLDialogElement>) {
  const contentElement = dialog.querySelector(
    "dialog > div"
  ) as HTMLDivElement | null;
  if (contentElement == null) {
    console.warn("No content div inside dialog element");
    continue;
  }

  // Allow dialog to close on backdrop click
  dialog.addEventListener("click", (event) => {
    // Do nothing if some child was clicked
    if (event.target !== dialog) return;

    // Get box position
    const rect = dialog.getBoundingClientRect();

    // Do nothing if the click was inside
    if (
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    ) {
      return;
    }

    // Close dialog
    dialog.close();
  });

  // Attach handler to close button
  dialog
    .querySelector("dialog > button")
    ?.addEventListener("click", () => dialog.close());

  // No idea why the contents get selected when clicking outside,
  // but let's prevent that
  dialog.addEventListener("selectstart", (event) => {
    if (event.target === dialog) event.preventDefault();
  });
}
